export type TrialVoucherContext = {
  voucher_type: 'phone_verification' | 'two_weeks_free';
  trial_region: 'kr' | 'global';
  trial_type: 'phone_verification' | 'two_weeks_free';
};

export type TrialVoucherActivationTrackingContext = TrialVoucherContext & {
  trial_source: string;
};

export const getTrialVoucherContext = (
  systemCampaignType?: string,
): TrialVoucherContext | null => {
  switch (systemCampaignType) {
    case 'PHONE_VERIFICATION_REWARD':
      return {
        voucher_type: 'phone_verification',
        trial_region: 'kr',
        trial_type: 'phone_verification',
      };
    case 'TWO_WEEKS_FREE':
      return {
        voucher_type: 'two_weeks_free',
        trial_region: 'global',
        trial_type: 'two_weeks_free',
      };
    case undefined:
    default:
      return null;
  }
};
